import { render, staticRenderFns } from "./CreateAndUpdate.vue?vue&type=template&id=73535a77"
import script from "./CreateAndUpdate.vue?vue&type=script&lang=js"
export * from "./CreateAndUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports